import React, {useEffect,useState} from "react";
import "./ProductRegal.scss";
import SwiperId from "react-id-swiper";
import {useHistory} from "react-router-dom";
import {useBasket, useDispatchBasket} from "../../hooks";
import {BasketAddRemove} from "..";
import {
    getCats_api,
    getMallCats_api,
    getProductsCategory_api,
    getProductsMall_api,
    getSampleProduct_api
} from "../../Services/apis";
import {convertRialToToman, getMallColor} from "../../Services";

// let merchantRegal = ""
// let catRegal = ""

const imageParamss = {
    slidesPerView: 'auto',
    spaceBetween: 40,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


const catParams = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}



function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }


    return "-"

}

function limitText(txt,length) {
    if(txt.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}

function CategoryRegal({item,sort=false}) {
    //hooks
    const history = useHistory();

    const [regalFlag,set_regalFlag] = useState(true)
    const [data,setData] = useState([])
    const [cats,setCats] = useState([])
    const [currentCat,set_currentCat] = useState(null)
    const [color,setColor] = useState("#f5f5f5")

    const [merchantRegal,set_merchantRegal] = useState("")
    const [catRegal,set_catRegal] = useState("")



    const [mallPrimaryColor, set_mallPrimaryColor] = useState('');
    const [mallSecondaryColor, set_mallSecondaryColor] = useState('');

    useEffect(()=>{
        let {primary, secondary} = getMallColor()
        set_mallPrimaryColor(primary)
        set_mallSecondaryColor(secondary)
    },[])

    useEffect( ()=>{
        getProductsMall()
    },[])

    const selectCat = (c)=>{
        set_currentCat(c)
        getCatProducts(c.uid)
        if(c.name)
            item.title = c.name
    }

    const getCatProducts = async (cId)=>{
        try{
            let split = item.items[0].text.split("@")
            //set for more product
            // merchantRegal = split[1]
            set_merchantRegal(split[1])
            // catRegal = cId
            set_catRegal(cId)
            console.log("######################################")
            const res = await getProductsCategory_api(split[1],cId,sortSelect)
            let proData = {data:res}
            set_regalFlag(false)
            setData(proData.data.results)
            set_regalFlag(true)
            if(item.items[0].link_to_uid)
                setColor(item.items[0].link_to_uid)
        }catch (e) {
            console.log(e)
        }

    }

    const getProductsMall = async ()=>{
        if(item.items[0].text){
            try{
                let split = item.items[0].text.split("@")
                //set for more product
                // merchantRegal = split[1]
                set_merchantRegal(split[1])

                // catRegal = split[0]
                set_catRegal(split[0])


                console.log("$$$$$$$$$$$$$$$$$$$$$$$$")
                const res = await getProductsCategory_api(split[1],split[0],sortSelect)
                let proData = {data:res}
                selectCat({uid:split[0]})
                setData(proData.data.results)
                getCats(split[1],split[2])
                if(item.items[0].link_to_uid)
                    setColor(item.items[0].link_to_uid)
            }catch(e){
                console.log(e)
            }
        }
    }

    const getCats = async(mId,pId)=>{
        try{
             const res = await getCats_api(mId,pId)
            let proData = {data:res}
            setCats(proData.data)
        }catch (e) {
            console.log(e)
        }
    }


    const seeMoreProduct = ()=>{

        history.push(`/dr-shop/search/${merchantRegal}/${catRegal}`)
    }

    const [sortSelect,set_sortSelect] = useState("discounts")
    const handleChangeSort = async (val)=>{
        set_sortSelect(val)
        // selectCat(currentCat)
        try{
            let split = item.items[0].text.split("@")
            //set for more product
            // merchantRegal = split[1]
            set_merchantRegal(split[1])
            // catRegal = currentCat.uid
            set_catRegal(currentCat.uid)
            console.log("-------------------------------------",val)
            const res = await getProductsCategory_api(split[1],currentCat.uid,val)
            let proData = {data:res}
            setData(proData.data.results)
            if(item.items[0].link_to_uid)
                setColor(item.items[0].link_to_uid)
        }catch (e) {
            console.log(e)
        }
    }

    return(
        // <span>swiper ...</span>
        <div style={{margin: "20px 16px 0 16px",padding:"10px",backgroundColor:color}} className="parent-regal">

            {cats && cats.length>0?
            <SwiperId {...catParams} >
                {cats.map(d=>{
                    return(
                        <div className="swiper-card-container cat-slide" style={currentCat?.uid===d.uid?{backgroundColor:color,color:"white"}:{backgroundColor:"white",color:"black"}} onClick={e=>{
                            selectCat(d)
                        }}>
                            <span>{d.name}</span>
                        </div>
                    )
                })}

            </SwiperId>:null}

            {regalFlag?<div className="online-off-section" style={{
                backgroundColor: "white",
                margin: "10px 0",
                padding: 8,
            }}>
                {data && data.length>0? <SwiperId {...imageParamss}>
                    <div className="swiper-card-container product-n-cardi"  style={{backgroundColor:"white",marginLeft:20}}>
                        <div className="swiper-card-body" >
                            <span>{item.title?item.title:"محصولات ویژه"}</span>

                            {sort?<div className="regal-sort-sec">
                                <select
                                    value={sortSelect}
                                    onChange={e=>{handleChangeSort(e.target.value)}}
                                    name="" id="">
                                    <option value="-discounts"> بیشترین تخفیف</option>
                                    <option value="-sell">پر فروش ترین</option>
                                </select>
                            </div>:null}

                        </div>
                    </div>
                    {data.map(i=>{
                        return(
                            <div style={{width:100}}>
                                <div className="swiper-card-container" style={{
                                    boxShadow:"1px 1px 4px #f3f3f3"
                                }} onClick={()=>{
                                    let split = item.items[0].text.split("@")
                                    history.push(`/dr-shop/detail/${split[1]}/${i.uid}`)
                                }}>
                                    <div className="swiper-card-body" >
                                        {/*<BasketAddRemove i={i}/>*/}
                                        <div className="swiper-card-body-image">
                                            {i.stock===0?<div className="notExist-badge">ناموجود</div>:null}
                                            <img src={i.image} alt=""/>
                                        </div>
                                    </div>
                                    <div className="price-section">
                                        <div className="price">
                                            {numberWithCommas(convertRialToToman(i.price))} تومان
                                        </div>
                                        {i.price_original-i.price>0?<div className="price-without-off">
                                            {numberWithCommas(i.price_original)}
                                        </div>:null}
                                    </div>
                                    {/*{i && i.discount_percentage!==0?*/}
                                    {/*    <div className="off">*/}
                                    {/*        <span>{i.discount_percentage+" % "}</span>*/}
                                    {/*    </div>:null*/}
                                    {/*}*/}
                                    <div className="info-section">
                                        <div className="name">{limitText(i.name,25)}</div>
                                        {/*<div className="weight">1500 گرمی میهن</div>*/}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    {/*<div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>*/}
                    {/*    <div className="swiper-card-body">*/}
                    {/*        <div className="swiper-more-card">*/}
                    {/*            <span>مشاهده محصولات </span>*/}
                    {/*            <span onClick={seeMoreProduct} className="swiper-more-card-btn">بیشتر</span>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="swiper-card-container product-cardi" style={{backgroundColor:"white"}}>
                        <div className="swiper-card-body">
                            <span></span>
                        </div>
                    </div>
                </SwiperId>:null}
            </div>:null}
            <div className="more-section-mobile">
                <span onClick={seeMoreProduct} style={{backgroundColor:mallPrimaryColor}}>مشاهده همه</span>
            </div>
        </div>

    )
}

export {CategoryRegal};
